
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { UseFormReturn } from "react-hook-form";
import { PoultryFormValues } from "@/types/stock";
import { UnitField } from "./UnitField";

interface PoultryFormFieldsProps {
  form: UseFormReturn<PoultryFormValues>;
}

export const PoultryFormFields = ({ form }: PoultryFormFieldsProps) => {
  const { register, watch, setValue } = form;
  const unit = watch("unit");
  const customUnit = watch("customUnit");

  return (
    <>
      <div className="space-y-2">
        <Label htmlFor="Race">Race de volaille</Label>
        <Input
          id="Race"
          {...register("Race")}
          required
          placeholder="Ex: Poulet de chair"
        />
      </div>

      <div className="space-y-2">
        <Label htmlFor="Age">Âge</Label>
        <Input
          id="Age"
          {...register("Age")}
          required
          placeholder="Ex: 3 mois"
        />
      </div>

      <div className="space-y-2">
        <Label htmlFor="Santé">État de santé</Label>
        <Input
          id="Santé"
          {...register("Santé")}
          required
          placeholder="Ex: Bon état"
        />
      </div>

      <div className="space-y-2">
        <Label htmlFor="Poids">Poids</Label>
        <Input
          id="Poids"
          {...register("Poids")}
          required
          placeholder="Ex: 2.5 kg"
        />
      </div>

      <div className="space-y-2">
        <Label htmlFor="Régime">Régime alimentaire</Label>
        <Input
          id="Régime"
          {...register("Régime")}
          required
          placeholder="Ex: Standard"
        />
      </div>

      <div className="grid grid-cols-2 gap-4">
        <div className="space-y-2">
          <Label htmlFor="quantity">Quantité</Label>
          <Input
            id="quantity"
            type="number"
            min="0"
            {...register("quantity")}
            required
          />
        </div>
        <div className="space-y-2">
          <Label htmlFor="minQuantity">Quantité minimum</Label>
          <Input
            id="minQuantity"
            type="number"
            min="0"
            {...register("minQuantity")}
            required
          />
        </div>
      </div>

      <UnitField
        unit={unit}
        customUnit={customUnit}
        onUnitChange={(value) => setValue("unit", value)}
        onCustomUnitChange={(value) => setValue("customUnit", value)}
        isPoultry={true}
      />

      <div className="space-y-2">
        <Label htmlFor="price">Prix Unitaire</Label>
        <Input
          id="price"
          type="number"
          min="0"
          {...register("price")}
          required
        />
      </div>
    </>
  );
};
